import { logError } from '~/utils/logError';
import { uploadsLogger } from '../../loggers';
import type { Uploader } from '../Uploader';

export const addUploaderTracking = (uploader: Uploader) => {
  // Error tracking in Bugsnag
  uploader.on('file-fetch-failed', (remoteFile, error) => {
    logError(error, { metaData: { remoteFile } });
  });

  uploader.on('upload-failed', (upload, error) => {
    logError(error, { metaData: { upload } });
  });

  // Tracking in Segment
  uploader.on('file-upload-attempted', (file) => {
    uploadsLogger('tracking for file-upload-attempted', file);
  });

  uploader.on('file-validation-failed', (file, error) => {
    uploadsLogger('tracking for file-validation-failed', file, error);
  });

  uploader.on('upload-started', (upload) => {
    uploadsLogger('tracking for upload-started', upload);
  });

  uploader.on('upload-finished', (upload) => {
    uploadsLogger('tracking for upload-finished', upload);
  });

  uploader.on('upload-failed', (upload, error) => {
    uploadsLogger('tracking for upload-failed', upload, error);
  });
};
